const recoverBtn = document.querySelectorAll('.recover');
const recover = document.querySelector('.recoverPassword');
const login = document.querySelector('.loginForm');

for (i = 0; i < recoverBtn.length; i++) {
    recoverBtn[i].addEventListener('click', function (e) {
        e.preventDefault();

        if (login.classList.contains('active')) {
            recover.style.display = 'flex';
            recover.classList.add('active');

            login.style.display = 'none';
            login.classList.remove('active');
        } else {
            login.style.display = 'flex';
            login.classList.add('active');

            recover.style.display = 'none';
            recover.classList.remove('active');
        }
    });
}

document.addEventListener("DOMContentLoaded", (e) => {
    let url = window.location.href;

    if (url.indexOf('/login#recover') != -1 ) {
        if (login.classList.contains('active')) {
            recover.style.display = 'flex';
            recover.classList.add('active');

            login.style.display = 'none';
            login.classList.remove('active');
        } else {
            login.style.display = 'flex';
            login.classList.add('active');

            recover.style.display = 'none';
            recover.classList.remove('active');
        }
    }
});